




































































































import { Component, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { Severity } from '@sentry/types';

import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

import { Doctor } from '@/plugins/podolib/services/doctor';

enum Steps {
  A_1 = 'a_1',
  A_2 = 'a_2',
  B_1 = 'b_1',
  B_2 = 'b_2',
  C_1 = 'c_1',
}

@Component({
  components: { ElementBgIcon },
})
export default class HomeWelcomeDialog extends MixinDialog {
  currentStep: Steps = Steps.A_1;
  pending = false;
  error: Error | null = null;

  A_1_hasKit: boolean | null = null;

  @Watch('currentStep')
  onCurrentStepChanged(value: Steps) {
    switch (value) {
      case Steps.B_2:
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('User ConfigureKitInitiated', {
          value: false,
        });
        break;
      case Steps.C_1:
        // Analytics
        this.$pdc.analytics?.actions.trackSuccess('User ConfigureKitInitiated', {
          value: true,
        });
        this.$pdc.bus!.emit('equipments:configure-kit-dialog:open');
        this.close();
        break;
    }
  }

  get Steps() {
    return Steps;
  }

  get doctor() {
    return this.$pdc.doctor!.current;
  }

  get stations() {
    return this.$pdc.entities!.stations.storedEntity;
  }

  set _A_1_hasKit(value: boolean) {
    this.A_1_hasKit = value;

    this.currentStep = value ? Steps.B_1 : Steps.A_2;
  }

  get kitStatus() {
    return this.A_1_hasKit ? 'KIT_UNCONFIGURED' : 'NO_KIT';
  }

  async saveKitStatus() {
    if (this.pending) return;

    try {
      // Reset flags
      this.error = null;
      // Set 'pending' flag
      this.pending = true;
      // Try to patch the doctor ...
      await this.$pdc.repository!.patchRessource({
        ressource: 'doctors',
        params: {
          _id: this.$pdc.doctor!.current._id,
        },
        data: {
          kitStatus: this.kitStatus,
        },
      });

      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User OnboardedHasKit', {
        value: this.A_1_hasKit,
      });

      // CLose dialog
      this.close();
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('User OnboardedHasKit', e, {
        value: this.A_1_hasKit,
      });
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
      // Reset 'A_1_hasKit' flag
      this.A_1_hasKit = null;
    }
  }

  _open() {
    if (!this.doctor.kitStatus && !this.stations.list.length) {
      /*// Skip initial step if kitStatus eq "KIT_UNCONFIGURED"
      if (this.doctor.kitStatus === 'KIT_UNCONFIGURED') {
        this.A_1_hasKit = true;
        this.currentStep = Steps.B_1;
      }*/

      this.currentStep = Steps.A_1;

      this.open();
    }
  }

  created() {
    this.$pdc.bus!.on('home:welcome-dialog:open', this._open);
  }

  mounted() {
    this._open();
  }

  beforeDestroy() {
    this.$pdc.bus!.off('home:welcome-dialog:open', this._open);
  }
}
